<template>
  <section class="Introduction__method_notes">
    <div class="inner">
      <h2 class="Head__frame Head__frame_blue">
        <span class="Head__frame_blue_inner">注意事項</span>
      </h2>
      <div class="Introduction__method_notes_area">
        <ul class="Introduction__method_notes_list">
          <li class="Introduction__method_notes_list_li">
            必ず本ページでコピーした招待URLからお申し込みください。お申し込みの際に、検索などそれ以外からお申込みをされた場合、キャンペーンを適用することができません。
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'IntroductionNote'
}
</script>
